import React, { useContext, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import Orange_White_Border_Btn from "../../common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import "./Change_Trading_Password_Modal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { forgetPassword } from "../../../../utils/apis/login/Login";
import { Context } from "../../../../utils/context";
import Successfull_Modal from "../successfull_modal/Successfull_Modal";
import classNames from "classnames";

const Change_Trading_Password_Modal = (props) => {
  const {
    register,
    handleSubmit,
    getValues,
    setError,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const { userdata, getuserData } = useContext(Context);
  const email = userdata?.email;

  const [modalShow, setModalShow] = useState(false);

  const onSubmit = async (data) => {
    const payload = {
      new_password: data.new_password,
      email,
    };

    try {
      const res = await forgetPassword(payload);
      if (res?.success) {
        setModalShow(true);
        getuserData(userdata?.id);
        setTimeout(() => {
          navigate("/my-account");
          setModalShow(false);
        }, 3000);
      } else {
        setError("new_password", { message: res?.message || "Error occurred" });
      }
    } catch (error) {
      console.error("API Error:", error);
      setError("new_password", { message: "Failed to update password" });
    }
  };

  return (
    <section className="Change_Trading_Password_Modal">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Change_Trading_Password_Modal Verification_Steps_Modal modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Trading Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="note_div">
            <p className="note">Account:</p>
            <p className="note">{userdata?.customer_no}</p>
          </div>

          <Form className="changes_pass_form" onSubmit={handleSubmit(onSubmit)}>

            <div className="outer_form_div">
              <Form.Group className="custom_form_group password_holder">
                <Form.Label className="black_input_label">Password</Form.Label>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter New Password"
                  {...register("new_password", {
                    required: "Password is required", // Validation rule for required field
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters long", // Validation rule for minimum length
                    },
                    pattern: {
                      value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                      message:
                        "Password must contain at least one uppercase letter, one lowercase letter, and one number", // Validation rule for password complexity
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.new_password,
                    "is-valid": getValues("new_password"),
                  })}
                />
                <div className="eye-icc">
                  <FontAwesomeIcon
                    icon={iconOne}
                    className="icon"
                    onClick={() => togglePasswordVisibility("password")}
                  />
                </div>
              </Form.Group>
              {errors?.new_password && (
                <div className="mt-2">
                  <sup className="text-danger">
                    {errors?.new_password?.message}
                  </sup>{" "}
                  {/* Display error message */}
                </div>
              )}
            </div>


            <div className="outer_form_div">
              <Form.Group className="custom_form_group password_holder">
                <Form.Label className="black_input_label">
                  Confirm Password
                </Form.Label>
                <Form.Control
                  type={showPasswordOne ? "text" : "password"}
                  placeholder="Confirm New Password"
                  {...register("confirm_password", {
                    required: "Confirm Password is required",
                    validate: (value) =>
                      value === getValues("new_password") ||
                      "Passwords do not match",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.confirm_password,
                    "is-valid": getValues("confirm_password"),
                  })}
                />
                <div className="eye-icc">
                  <FontAwesomeIcon
                    icon={iconTwo}
                    className="icon"
                    onClick={() => togglePasswordVisibility("reenterPassword")}
                  />
                </div>

              </Form.Group>
              {errors?.confirm_password && (
                <div className="mt-2">
                  <sup className="text-danger">
                    {errors?.confirm_password?.message}
                  </sup>
                </div>
              )}
            </div>

            <div className="btn_holder">
              <Orange_White_Border_Btn
                btn_name="Change Password"
                onClick={handleSubmit(onSubmit)}
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <Successfull_Modal
        message="Password Updated Successfully"
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </section>
  );
};

export default Change_Trading_Password_Modal;
